import * as React from 'react'
import { CalendlyEvent } from '../../calendly'

export type DateAndTimeSelectedEvent = MessageEvent<{
    event: CalendlyEvent.DATE_AND_TIME_SELECTED
    payload: {}
}>

export type EventScheduledEvent = MessageEvent<{
    event: CalendlyEvent.EVENT_SCHEDULED
    payload: {
        event: {
            uri: string
        }
        invitee: {
            uri: string
        }
    }
}>

export type CalendlyEventHandlers = {
    onDateAndTimeSelected?: (e: DateAndTimeSelectedEvent) => any
    onEventScheduled?: (e: EventScheduledEvent) => any
}

const EVENT_NAME = 'message'

export default function useCalendlyEventListener(
    eventHandlers: CalendlyEventHandlers
) {
    const { onDateAndTimeSelected, onEventScheduled } = eventHandlers || {}

    React.useEffect(() => {
        const onMessage = (e: MessageEvent) => {
            const eventName = e.data.event

            if (eventName === CalendlyEvent.DATE_AND_TIME_SELECTED) {
                if (onDateAndTimeSelected) onDateAndTimeSelected(e)
            } else if (eventName === CalendlyEvent.EVENT_SCHEDULED) {
                if (onEventScheduled) onEventScheduled(e)
            }
        }

        window.addEventListener(EVENT_NAME, onMessage)

        return function cleanup() {
            window.removeEventListener(EVENT_NAME, onMessage)
        }
    }, [onDateAndTimeSelected, onEventScheduled])
}
